<template>
  <div style="width: 100%;">
    <headNavBar
      title="意见反馈"
      right-text="提交"
      @click-right="onRightClick"
    />
    <van-field
      v-model="value"
      placeholder="您的意见是我们前进的动力，感谢您的使用"
      type="textarea"
      rows="8"
      style="border-bottom:1px solid #eee;border-top:0;"
    />
  </div>
</template>

<script>
import { Field } from "vant";
export default {
  data() {
    return {
      value: "",
    };
  },
  components: {
    [Field.name]: Field,
  },
  methods: {
    onRightClick() {},
  },
};
</script>

<style lang="less" scoped>
/deep/.van-nav-bar__text {
  color: black !important;
  font-size: 0.4rem;
}
</style>
